import React from 'react';
import { Gift as GiftModel } from 'acscp/store';
import style from './giftDetailsPage.module.scss';
import { BasketGiftQuantityModifier } from 'acscp/components/loyalty/basketGiftQuantityModifier';
import { FormattedMessage } from 'react-intl';
import { CachedImage } from 'acscp/components/common/cachedImage';
import { ConstrainedImage } from 'acscp/components/common/constrainedImage';

interface GiftDetailsPageOwnProps {
    gift: GiftModel;
}

export class GiftDetailsPage extends React.Component<GiftDetailsPageOwnProps, {}> {
    render(): JSX.Element | null {
        const { gift } = this.props;
        const imageUrl = gift.image ? gift.image.thumbnailUrl : undefined;

        return (
            <div className={style.GiftDetailsPage}>
                <div className={style.ImageContainer}>
                    <CachedImage src={imageUrl} />
                </div>
                <div className={style.DetailsContainer}>
                    <p className={style.Title}>{gift.name}</p>
                    <div className={style.TitleSeparator} />
                    <p className={style.Price}>
                        <FormattedMessage
                            id={'components.gifts.giftDetails.price'}
                            defaultMessage={`{price, number} points`}
                            values={{price: gift.price}}
                        />
                    </p>
                    <p className={style.Description}>{gift.longDescription}</p>
                    <div className={style.ButtonContainer}>
                        <BasketGiftQuantityModifier gift={gift} counterOnly={false} />
                    </div>
                </div>
            </div>
        );
    }
}
